<template>
    <Head title="Search Results" />
    <div
        v-show="show_get_alert"
        class="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-50"
    >
        <div
            class="absolute -translate-y-1/2 top-1/2 -translate-x-1/2 left-1/2 z-20"
        >
            <SignUpToGetAlerts @closeModal="show_get_alert = false" />
        </div>
    </div>
    <div
        class="max-w-7xl border mx-auto my-8 bg-white rounded-3xl shadow divide-y transition-colors"
    >
        <div class="">
            <div class="flex lg:flex-row flex-col-reverse items-center space-x-4">
                <h1
                    class="ml-8 text-lg tracking-wide text-black font-semibold pt-8 pb-4"
                >
                    Results Based on Your Search
                </h1>
                <button
                    class="flex items-center border-2 rounded-md space-x-2 text-blue-600 hover:bg-blue-600 hover:text-white border-blue-600 px-6 py-2 mt-4"
                    @click="show_get_alert = !show_get_alert"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-7 h-7"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"
                        />
                    </svg>

                    <span class="font-bold">Get Job Alert</span>
                </button>
            </div>
            <!-- <div
                class="grid lg:grid-cols-5 grid-cols-12 place-items-center lg:ml-4 lg:w-1/2 tracking-wide cursor-pointer"
            >
                <button
                    class="block py-4 lg:col-span-1 col-span-3 -mb-0.5 w-full lg:text-sm text-xs text-center first-letter:uppercase z-10"
                    v-for="option in visibleFilterOptions"
                    :key="option.label"
                    :class="[
                        option.label === activeFilterOption
                            ? 'text-black border-b-2  border-black font-semibold'
                            : '',
                    ]"
                    @click="changeActiveOption(option)"
                >
                    {{ option.label }}
                </button>
            </div> -->
        </div>
        <template v-if="jobs.length">
            <JobCard
                v-for="job in jobs"
                :job="job"
                :key="job.id"
                class="hover:bg-gray-50 transition"
            />
        </template>
        <template v-if="externalJobs.length">
            <ExternalJobCard
                v-for="externalJob in externalJobs"
                :job="externalJob"
                :key="externalJob.id"
                class="hover:bg-gray-50 transition"
            />
        </template>
        <div
            v-if="!jobs.length && !externalJobs.length"
            class="text-center py-12 space-y-4"
        >
            <EmojiSadIcon class="inline-block h-16 w-16 text-gray-300" />
            <p class="font-medium text-sm text-gray-700">
                We couldn't find any jobs.
            </p>
        </div>
        <!-- Disabled for now! -->
        <!-- <div class="py-4 flex justify-center">
      <Pagination :links="jobs.links" />
    </div> -->
    </div>
</template>

<script setup>
import { Head } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { EmojiSadIcon } from "@heroicons/vue/outline";

import JobCard from "@/components/Jobs/JobCard";
import SignUpToGetAlerts from "@/components/Drivers/SignUpToGetAlerts.vue";
import ExternalJobCard from "@/components/Jobs/ExternalJobCard.vue";
// import Pagination from "@/components/Pagination";
import { ref, computed } from "vue";

const { jobs, user, externalJobs } = defineProps({
    jobs: Array,
    user: Object,
    externalJobs: { type: Array, default: () => [] },
});

const show_get_alert = ref(false);
const activeFilterOption = ref("");
const searchParams = new URLSearchParams(window.location.search);
const filterOption = searchParams.get("filter_option");

const isAdmin = computed(() => user !== null && user.role.includes("admin"));
const isAgent = computed(
    () =>
        user !== null &&
        (user.role.includes("agent") ||
            user.role.includes(
                "Restricted Agent to companies US Xpress, Heartland and DB Schenker"
            ))
);


const filterOptions = ref([
    { label: "open", visible: true },
    { label: "closed", visible: isAdmin || isAgent },
    { label: "ask", visible: true },
    { label: "hidden", visible: isAdmin },
]);

const visibleFilterOptions = computed(() =>
    filterOptions.value.filter((option) => option.visible)
);

const isValid = (option) =>
    Boolean(visibleFilterOptions.value.find(({ label }) => label === option));

const changeActiveOption = ({ label }) => {
    /**
     * Here I am just adding a check to make sure the user can filter by that option.
     * Basically what you were doing in the `if` blocks in the watcher but a bit
     * cleaner.
     */
    if (!isValid(label)) return;

    activeFilterOption.value = label;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("filter_option", label);
    const queryString = searchParams.toString();
    const url =
        window.location.pathname + (queryString ? `?${queryString}` : "");

    Inertia.get(url);
};

if (isValid(filterOption)) activeFilterOption.value = filterOption;
</script>
